import React, {memo, useEffect, useRef, useState} from 'react';
import {Loader} from "../../main/Loading";
import {useSelector, useStore} from "react-redux";
import {saveIntegrationLog} from "../../redux/actions";
import {useUrlReachable} from "../../hooks/useUrlReachable";
import CTR from "../../util/receiptTemplate";

const saveResponse = (responseUrl, surveyData, metaData, store, logParams, retry=0) => {
    fetch(responseUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...surveyData,
            responseMeta: {
                ...metaData
            }
        })
    }).then(response => {
            if (!response.ok) {
                return new Promise((resolve, reject) => {
                    reject(response);
                });
            }
            return response.json();
        })
        .then(data => {
            console.log('Response:', data);
        }, (response) => {
            console.log({response});
            if(retry < 1){
                saveResponse(responseUrl, surveyData, metaData, store, logParams, retry + 1);
            }else{
                store.dispatch(saveIntegrationLog("decathlonFeedback", {
                    error: "failed to submit a survey",
                    status: response.status,
                    message: response.message
                }, logParams.url, logParams.clientCode, logParams.sessionKey));
            }
        }).catch(e => {
            store.dispatch(saveIntegrationLog("decathlonFeedback", {
                error: "failed to submit a survey",
                message: e.message
            }, logParams.url, logParams.clientCode, logParams.sessionKey));
        });
}

const getMetaDataFromState = (state, type) => {
    let data = {
        isIgnored: false,
        isTimedOut: false,
        countryCode: state.rootReducer.erplyConf.DKTCountryCode,
        countryName: state.rootReducer.erplyConf.DKTCountryCode,
        storeCode: state.rootReducer.warehouse.code,
        storeName: state.rootReducer.warehouse.name,
        tillId: state.rootReducer.pos.name,
        tillType: state.rootReducer.cashierMode ? 'EPOS' : 'SCO ' + (state.rootReducer.operationMode)
    };
    if(type === 'customer'){
        if(typeof state.rootReducer?.customer?.rawData?.sub !== "undefined"){
            data.memberId = state.rootReducer?.customer?.rawData?.sub;
        }
        if(CTR.lastReceiptNumber !== false){
            data.receiptNumber = CTR.lastReceiptNumber;
        }
    }
    return data;
}
const getLogParamsFromState = (state) => {
    if(state.rootReducer.erplyServiceEndpoints === false){
        return {};
    }
    return {
        url: state.rootReducer.erplyServiceEndpoints['integration-logs'].url,
        clientCode: state.rootReducer.user.clientCode,
        sessionKey: state.rootReducer.user.sessionKey
    }
}

const getUrl = (conf, type, lang) => {
    return conf[type].url + "&timer=" + conf[type].timeout + "&language=" + lang;
}

const Iframe = memo(({iframeRef, conf, type, lang}) => {
    const src = getUrl(conf, type, lang);

    return (
        <iframe
            ref={iframeRef}
            src={src}
            style={{
                position: "fixed",
                inset: 0,
                width: "100%",
                height: "100%",
                border: "none",
                zIndex: 98,
                backgroundColor: "#fff"
            }}
        />
    );
});
export default function ({type, onDone, conf= window.AppConf.feedbackApp}) {
    const metaData = useSelector(state => getMetaDataFromState(state, type));
    const logParams = useSelector(getLogParamsFromState);
    const lang = useSelector(state => state.localize.activeLocale);
    const store = useStore();
    const [firstRenderState, setFirstRenderState] = useState(null);
    const iframeRef = useRef(null);
    const [showCloseButton, setShowCloseButton] = useState(false);

    const src = getUrl(conf, type, lang);
    const url = new URL(src);

    const status = useUrlReachable(src);

    useEffect(() => {
        if(firstRenderState === null){
            setFirstRenderState({
                logParams,
                metaData
            });
        }

        const closeButtonTimeout = setTimeout(() => {
            setShowCloseButton(true);
        }, 11000);
        const handleMessage = (event) => {
            // Verify origin for security
            if (event.origin !== url.origin) return;
            console.log('Message from iframe:', event.data);
            const surveyData = event.data.data;
            if(event.data.event === 'surveyCompleted'){
                saveResponse(conf.responseUrl, surveyData, firstRenderState.metaData, store, firstRenderState.logParams);
            }else if(event.data.event === 'surveyTimeOut'){
                saveResponse(conf.responseUrl, surveyData, {...firstRenderState.metaData, isTimedOut: true}, store, firstRenderState.logParams);
            }else if(event.data.event === 'surveyIgnored'){
                saveResponse(conf.responseUrl, surveyData, {...firstRenderState.metaData, isIgnored: true}, store, firstRenderState.logParams);
            }
            onDone();
        };

        window.addEventListener('message', handleMessage);

        if(status === 'unreachable'){
            onDone();
        }

        return () => {
            clearTimeout(closeButtonTimeout);
            window.removeEventListener('message', handleMessage);
        };
    }, [status, showCloseButton]);

    return (
        <div>
            {showCloseButton ? <div style={{
                zIndex: 99,
                top: 10,
                left: 10
            }} onClick={ e => {
                onDone();
            }} className={"modalCloseButton blueCircleBackground"}>
                <i className="icoFont">&#xeee1;</i>
            </div> : ''}
            <Iframe
                conf={conf}
                type={type}
                lang={lang}
                iframeRef={iframeRef}
            />
            { status === 'loading' ? <div style={{
                position: "fixed",
                width: "100%",
                height: "100%",
                zIndex: 100
            }}>
                <Loader/>
            </div> : ''}
        </div>
    );
}
